import React from "react";
import { Box, Typography } from "@mui/material";
import { cutCorner } from "../../../components/ui/GaPrimitives";

export function MythOrFactCard({
  title,
  prompt,
  mythLabel = "MYTH",
  factLabel = "FACT",
  onAnswer,
  disabled = false,
  sx,
}) {
  return (
    <Box
      className="neon-wrapper"
      sx={{
        minWidth: 0,
        height: { xs: 186, md: 240, lg: 260 },
        clipPath: cutCorner(12),
        ...sx,
      }}
    >
      <Box
        className="neon-inner"
        sx={{
          position: "relative",
          zIndex: 1,
          bgcolor: "#15170F",
          p: { xs: "13px", md: "20px" },
          boxSizing: "border-box",
          clipPath: cutCorner(12),
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
      >
      <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
        <Typography
          sx={{
            fontFamily: "'Rajdhani', sans-serif",
            fontWeight: 700,
            fontSize: 11,
            letterSpacing: "1px",
            color: "#B8EE3C",
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        component="p"
        sx={{
          m: 0,
          mt: { xs: "10px", md: "16px" },
          mb: "8px",
          flex: "1 1 auto",
          minHeight: 48,
          position: "relative",
          zIndex: 2,
          color: "#F2FAE6",
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 500,
          fontSize: { xs: "12px", md: "14px" },
          lineHeight: { xs: "17px", md: "20px" },
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflow: "visible",
        }}
      >
        {prompt}
      </Box>
      <Box sx={{ display: "flex", gap: "10px", flexShrink: 0 }}>
        {[
          { key: "myth", label: mythLabel },
          { key: "fact", label: factLabel },
        ].map((option) => (
          <Box
            key={option.key}
            component="button"
            type="button"
            disabled={disabled}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              if (disabled) return;
              onAnswer?.(option.key);
            }}
            sx={{
              flex: 1,
              height: 36,
              bgcolor: "#0D0F0A",
              border: "1px solid #262B1C",
              color: "#FFFFFF",
              fontFamily: "'Rajdhani', sans-serif",
              fontWeight: 700,
              fontSize: 12,
              letterSpacing: "1px",
              cursor: "pointer",
              outline: "none",
              WebkitTapHighlightColor: "transparent",
              "&:focus, &:focus-visible, &:active": {
                outline: "none",
              },
            }}
          >
            {option.label}
          </Box>
        ))}
      </Box>
      </Box>
    </Box>
  );
}
